import { createServerOnlyFn } from "@tanstack/react-start";
import { getCatalog } from "@/lib/core/catalog-core.server";

export const listingPageApiRoute = {
    server: {
        handlers: {
            GET: createServerOnlyFn(
                async ({ params }: { params: { listingId: string } }) => {
                    const catalog = await getCatalog();
                    const page = await catalog.listings.getListingPage(
                        params.listingId,
                    );
                    return page
                        ? Response.json(page)
                        : Response.json(
                              { error: "Listing not found" },
                              { status: 404 },
                          );
                },
            ),
        },
    },
};
